import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import PandabuySpreadsheetGuide from '@/pages/article/pandabuy-spreadsheet-guide/page';
import PandabuySpreadsheetShoes from '@/pages/article/pandabuy-spreadsheet-shoes/page';
import PandabuySpreadsheetHoodies from '@/pages/article/pandabuy-spreadsheet-hoodies/page';
import PandabuySpreadsheetTshirts from '@/pages/article/pandabuy-spreadsheet-t-shirts/page';
import PandabuySpreadsheetJackets from '@/pages/article/pandabuy-spreadsheet-jackets/page';
import PandabuySpreadsheetBags from '@/pages/article/pandabuy-spreadsheet-bags/page';
import PandabuySpreadsheetAccessories from '@/pages/article/pandabuy-spreadsheet-accessories/page';
import PandabuySpreadsheetJerseys from '@/pages/article/pandabuy-spreadsheet-jerseys/page';
import PandabuySpreadsheetStreetwear from '@/pages/article/pandabuy-spreadsheet-streetwear/page';
import PandabuySpreadsheetTrending from '@/pages/article/pandabuy-spreadsheet-trending/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/article/pandabuy-spreadsheet-guide', element: <PandabuySpreadsheetGuide /> },
  { path: '/article/pandabuy-spreadsheet-shoes', element: <PandabuySpreadsheetShoes /> },
  { path: '/article/pandabuy-spreadsheet-hoodies', element: <PandabuySpreadsheetHoodies /> },
  { path: '/article/pandabuy-spreadsheet-t-shirts', element: <PandabuySpreadsheetTshirts /> },
  { path: '/article/pandabuy-spreadsheet-jackets', element: <PandabuySpreadsheetJackets /> },
  { path: '/article/pandabuy-spreadsheet-bags', element: <PandabuySpreadsheetBags /> },
  { path: '/article/pandabuy-spreadsheet-accessories', element: <PandabuySpreadsheetAccessories /> },
  { path: '/article/pandabuy-spreadsheet-jerseys', element: <PandabuySpreadsheetJerseys /> },
  { path: '/article/pandabuy-spreadsheet-streetwear', element: <PandabuySpreadsheetStreetwear /> },
  { path: '/article/pandabuy-spreadsheet-trending', element: <PandabuySpreadsheetTrending /> },
];

export default routes;